import Card from 'antd/lib/card';
import Form from 'antd/lib/form';
import Col from 'antd/lib/grid/col';
import Row from 'antd/lib/grid/row';
import Spin from 'antd/lib/spin';
import AvatarUploader from 'components/AvatarUploader/AvatarUploader';
import SwitchStatus from 'components/Switch/Switch';
import TreeSelectDropdown from 'components/TreeSelect/TreeSelect';
import { API_ORGANIZATION_ROUTE } from 'config/api-consts';
import { generalLanguageKeys } from 'config/consts';
import { crudService, formService, routerService } from 'core/services';
import { Organization } from 'models/Organization';
import { OrganizationFilter } from 'models/OrganizationFilter';
import { Status } from 'models/Status';
import React from 'react';
import { useTranslation } from 'react-i18next';
import nameof from 'ts-nameof.macro';
import { organizationRepository } from '../OrganizationRepository';
import './OrganizationDetail.scss';
import { Switch } from 'antd';
import SelectAutoComplete from 'components/SelectAutoComplete/SelectAutoComplete';
import { CurrencyFilter } from 'models/CurrencyFilter';
import { Currency } from 'models/Currency';
const { Item: FormItem } = Form;

function OrganizationTreeDetail() {
  const [translate] = useTranslation();
  const { validAction } = crudService.useAction(
    'organization',
    API_ORGANIZATION_ROUTE,
    'portal',
  );

  const res = window.location.href.split('=');
  let idOrg: number = null;
  if (res && res.length > 1) {
    idOrg = Number(res[1]);
  }

  // Service goback
  const [handleGoBack] = routerService.useGoBack();
  // Hooks, useDetail, useChangeHandler
  const [
    organization,
    setOrganization,
    loading,
    ,
    isDetail,
    handleSave,
  ] = crudService.useDetail(
    Organization,
    organizationRepository.get,
    organizationRepository.save,
  );

  const [
    handleChangeSimpleField,
    handleChangeObjectField,
  ] = crudService.useChangeHandlers<Organization>(
    organization,
    setOrganization,
  );

  const [currencyFilter, setCurrencyFilter] = React.useState<CurrencyFilter>(
    new CurrencyFilter(),
  );
  // Enums  -----------------------------------------------------------------------------------------------------------------------------------------

  const defaultCurrecyList: Currency[] = crudService.useDefaultList<Currency>(
    organization.currency,
  );

  const [statusList] = crudService.useEnumList<Status>(
    organizationRepository.singleListStatus,
  );

  const [organizationFilter, setOrganizationFilter] = React.useState<
    OrganizationFilter
  >(new OrganizationFilter());

  React.useEffect(() => {
    let parentId: number = null;
    if (organization.parentId === undefined) {
      if (idOrg && idOrg !== null) {
        parentId = idOrg;
        setOrganization({
          ...organization,
          parentId,
        });
        handleChangeSimpleField(nameof(organization.parentId));
      }
    }
  }, [
    setOrganization,
    idOrg,
    handleChangeSimpleField,
    organization.parentId,
    organization,
  ]);
  const handleChangeImage = React.useCallback(
    (value: string) => {
      setOrganization({
        ...organization,
        avatar: value,
      });
    },
    [setOrganization, organization],
  );

  return (
    <div className="page detail-page organization-detail">
      <Spin spinning={loading}>
        <Card
          title={
            <div className="d-flex justify-content-between">
              <div className="d-flex justify-content-start">
                <button
                  className="btn btn-link btn-back"
                  onClick={handleGoBack}
                >
                  <i className="fa fa-chevron-left"></i>
                </button>
                <div className="pt-1 pl-1">
                  {isDetail
                    ? translate('general.detail.title')
                    : translate(generalLanguageKeys.actions.create)}
                </div>
              </div>
              <div>
                <button
                  className="btn btn-sm btn-outline-primary float-right ml-2 mr-2"
                  onClick={handleGoBack}
                >
                  <i className="fa mr-2 fa-times-circle" />
                  {translate(generalLanguageKeys.actions.cancel)}
                </button>
                {isDetail && validAction('update') && (
                  <button
                    className="btn btn-sm btn-primary float-right"
                    onClick={handleSave}
                  >
                    <i className="fa mr-2 fa-save" />
                    {translate(generalLanguageKeys.actions.save)}
                  </button>
                )}
                {!isDetail && validAction('create') && (
                  <button
                    className="btn btn-sm btn-primary float-right"
                    onClick={handleSave}
                  >
                    <i className="fa mr-2 fa-save" />
                    {translate(generalLanguageKeys.actions.save)}
                  </button>
                )}
              </div>
            </div>
          }
        >
          <Form>
            <Row>
              <Col span={11}>
                {validAction('saveImage') && (
                  <FormItem>
                    <span className="label-input ml-1 mb-3 mt-2">
                      {translate('organizations.avatar')}
                    </span>
                    <AvatarUploader
                      onUpload={organizationRepository.saveImage}
                      defaultValue={organization?.avatar}
                      onChange={handleChangeImage}
                      isAspectRatio={true}
                    />
                  </FormItem>
                )}
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <FormItem
                  validateStatus={formService.getValidationStatus<Organization>(
                    organization.errors,
                    nameof(organization.code),
                  )}
                  help={organization.errors?.code}
                >
                  <span className="label-input ml-1">
                    {translate('organizations.code')}
                    <span className="text-danger">*</span>
                  </span>
                  <input
                    type="text"
                    defaultValue={organization.code}
                    className="form-control form-control-sm"
                    onChange={handleChangeSimpleField(
                      nameof(organization.code),
                    )}
                    placeholder={translate('organizations.placeholder.code')}
                  />
                </FormItem>
                <FormItem
                  validateStatus={formService.getValidationStatus<Organization>(
                    organization.errors,
                    nameof(organization.purchaseOrganization),
                  )}
                  help={organization.errors?.purchaseOrganization}
                >
                  <span className="label-input ml-1">
                    {translate('organizations.purchaseOrganization')}
                  </span>
                  <input
                    type="text"
                    defaultValue={organization.purchasingOrganization}
                    className="form-control form-control-sm"
                    onChange={handleChangeSimpleField(
                      nameof(organization.purchasingOrganization),
                    )}
                    placeholder={translate(
                      'organizations.placeholder.purchaseOrganization',
                    )}
                  />
                </FormItem>
                <FormItem
                  validateStatus={formService.getValidationStatus<Organization>(
                    organization.errors,
                    nameof(organization.name),
                  )}
                  help={organization.errors?.name}
                >
                  <span className="label-input ml-1">
                    {translate('organizations.name')}
                    <span className="text-danger">*</span>
                  </span>
                  <input
                    type="text"
                    defaultValue={organization.name}
                    className="form-control form-control-sm"
                    onChange={handleChangeSimpleField(
                      nameof(organization.name),
                    )}
                    placeholder={translate('organizations.placeholder.name')}
                  />
                </FormItem>
                {validAction('singleListStatus') && (
                  <FormItem
                    validateStatus={formService.getValidationStatus<
                      Organization
                    >(organization.errors, nameof(organization.status))}
                    help={organization.errors?.status}
                  >
                    <span className="label-input ml-1">
                      {translate('organizations.status')}
                    </span>
                    <SwitchStatus
                      checked={organization.statusId === statusList[1]?.id}
                      list={statusList}
                      onChange={handleChangeObjectField(
                        nameof(organization.status),
                      )}
                    />
                  </FormItem>
                )}
                {validAction('singleListOrganization') && (
                  <FormItem
                    validateStatus={formService.getValidationStatus<
                      Organization
                    >(organization.errors, nameof(organization.organization))}
                    help={organization.errors?.organization}
                  >
                    <span className="label-input ml-1">
                      {translate('organizations.organization')}
                    </span>
                    <TreeSelectDropdown
                      defaultValue={isDetail ? organization.parent?.id : idOrg}
                      value={organization.parent?.id || idOrg}
                      mode="single"
                      onChange={handleChangeObjectField(
                        nameof(organization.parent),
                      )}
                      modelFilter={organizationFilter}
                      setModelFilter={setOrganizationFilter}
                      getList={organizationRepository.singleListOrganization}
                      searchField={nameof(organizationFilter.id)}
                      placeholder={translate(
                        'organizations.placeholder.organization',
                      )}
                    />
                  </FormItem>
                )}

                <FormItem
                  validateStatus={formService.getValidationStatus<Organization>(
                    organization.errors,
                    nameof(organization.useAsGenerator),
                  )}
                  help={organization.errors?.useAsGenerator}
                >
                  <span className="label-input ml-1">
                    {translate('organizations.useAsGenerator')}
                  </span>
                  <Switch
                    checked={organization?.useAsGenerator === true}
                    onChange={(check: boolean) => {
                      handleChangeSimpleField('useAsGenerator')(check);
                    }}
                  ></Switch>
                </FormItem>
              </Col>

              <Col lg={12}>
                <FormItem
                  validateStatus={formService.getValidationStatus<Organization>(
                    organization.errors,
                    nameof(organization.address),
                  )}
                  help={organization.errors?.address}
                >
                  <span className="label-input ml-1">
                    {translate('organizations.address')}
                  </span>
                  <input
                    type="text"
                    defaultValue={organization.address}
                    className="form-control form-control-sm"
                    onChange={handleChangeSimpleField(
                      nameof(organization.address),
                    )}
                    placeholder={translate('organizations.placeholder.address')}
                  />
                </FormItem>
                <FormItem
                  validateStatus={formService.getValidationStatus<Organization>(
                    organization.errors,
                    nameof(organization.purchasingGroup),
                  )}
                  help={organization.errors?.purchingGroup}
                >
                  <span className="label-input ml-1">
                    {translate('organizations.purchaseGroup')}
                  </span>
                  <input
                    type="text"
                    defaultValue={organization.purchasingGroup}
                    className="form-control form-control-sm"
                    onChange={handleChangeSimpleField(
                      nameof(organization.purchasingGroup),
                    )}
                    placeholder={translate(
                      'organizations.placeholder.purchaseGroup',
                    )}
                  />
                </FormItem>
                <FormItem
                  validateStatus={formService.getValidationStatus<Organization>(
                    organization.errors,
                    nameof(organization.email),
                  )}
                  help={organization.errors?.email}
                >
                  <span className="label-input ml-1">
                    {translate('organizations.email')}
                  </span>
                  <input
                    type="text"
                    defaultValue={organization.email}
                    className="form-control form-control-sm"
                    onChange={handleChangeSimpleField(
                      nameof(organization.email),
                    )}
                    placeholder={translate('organizations.placeholder.email')}
                  />
                </FormItem>
                <FormItem
                  validateStatus={formService.getValidationStatus<Organization>(
                    organization.errors,
                    nameof(organization.phone),
                  )}
                  help={organization.errors?.phone}
                >
                  <span className="label-input ml-1">
                    {translate('organizations.phone')}
                  </span>
                  <input
                    type="text"
                    defaultValue={organization.phone}
                    className="form-control form-control-sm"
                    onChange={handleChangeSimpleField(
                      nameof(organization.phone),
                    )}
                    placeholder={translate('organizations.placeholder.phone')}
                  />
                </FormItem>
                <FormItem
                  validateStatus={formService.getValidationStatus<Organization>(
                    organization.errors,
                    nameof(organization.taxCode),
                  )}
                  help={organization.errors?.taxCode}
                >
                  <span className="label-input ml-1">
                    {translate('organizations.taxCode')}
                  </span>
                  <input
                    type="text"
                    defaultValue={organization.taxCode}
                    className="form-control form-control-sm"
                    onChange={handleChangeSimpleField(
                      nameof(organization.taxCode),
                    )}
                    placeholder={translate('organizations.placeholder.taxCode')}
                  />
                </FormItem>
                {organization?.level === 2 && (
                  <FormItem
                    validateStatus={formService.getValidationStatus<
                      Organization
                    >(organization.errors, nameof(organization.currency))}
                    help={organization.errors?.currency}
                  >
                    <span className="label-input ml-1">
                      {translate('organizations.currency')}
                    </span>
                    <SelectAutoComplete
                      value={organization?.currency?.id}
                      onChange={handleChangeObjectField(
                        nameof(organization.currency),
                      )}
                      getList={organizationRepository.singleListCurrency}
                      modelFilter={currencyFilter}
                      setModelFilter={setCurrencyFilter}
                      searchField={nameof(currencyFilter.name)}
                      searchType={nameof(currencyFilter.name.contain)}
                      placeholder={translate(
                        'organizations.placeholder.currency',
                      )}
                      list={defaultCurrecyList}
                      allowClear={true}
                    />
                  </FormItem>
                )}
              </Col>
            </Row>
          </Form>
        </Card>
      </Spin>
    </div>
  );
}

export default OrganizationTreeDetail;
